import { Injectable, ViewContainerRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from '@core/components/confirm/confirm.component';
import { PromptComponent } from '@core/components/prompt/prompt.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SxDialogService {
  rootViewContainer: ViewContainerRef;

  constructor(public dialog: MatDialog, private translate: TranslateService) {}

  openDialog<T>(componenRef: ComponentType<T>, data: any, options?: any) {
    let defaultProperties = {
      hasBackdrop: true,
      panelClass: 'sx-dialog',
      backdropClass: 'sx-dialog__backdrop',
      data: data
    };

    options = options ? options : {};
    if (this.dialog.openDialogs.length === 0) {
      return this.dialog.open(componenRef, { ...defaultProperties, ...options });
    }
  }

  confirmDialog(message: string, confirmButtonText = 'Spara och stäng', header?: string) {
    if (!header) {
      header = this.translate.instant('core.dialog.confirm');
    }
    return this.dialog.open(ConfirmComponent, {
      hasBackdrop: true,
      panelClass: 'sx-dialog',
      backdropClass: 'sx-dialog__backdrop',
      data: { message: message, confirmButtonText: confirmButtonText, header: header }
    });
  }

  promptDialog(message: string, buttonText = 'Ok', header?: string) {
    if (!header) {
      header = this.translate.instant('core.dialog.prompt');
    }
    return this.dialog.open(PromptComponent, {
      hasBackdrop: true,
      panelClass: 'sx-dialog',
      backdropClass: 'sx-dialog__backdrop',
      data: { message: message, buttonText: buttonText, header: header }
    });
  }
}
